var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTidalVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 132.497 132.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386",
    transform: "translate(-2545.925 -442.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M2763.938,489.922a64.8,64.8,0,1,1-64.8-64.815A64.806,64.806,0,0,1,2763.938,489.922Z",
    transform: "translate(-87 19)",
    fill: "none",
    stroke: "#272427",
    strokeMiterlimit: 10,
    strokeWidth: 2.835
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M2773.866,535.184c-4.116-2.954-9.8-8.635-12.031-12.775-5.49-10.2-6.953-21.386-9.467-21.386-5.486,0-9.541,37.317-16.458,37.317v-.277c-12.077,0-19.511-7.687-23.739-15.935-5.224-10.206-6.615-21.387-9.01-21.387-5.22,0-9.079,37.322-15.661,37.322-12.077,0-19.514-7.687-23.739-15.935-5.221-10.2-6.613-21.381-9.009-21.381-2.61,0-6.415,16.461-8.854,25.79",
    transform: "translate(-98.556 -10.62)",
    fill: "none",
    stroke: "#272427",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.126
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTidalVolume);
export default __webpack_public_path__ + "static/media/TidalVolume.330ef47f.svg";
export { ForwardRef as ReactComponent };